import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Form,
} from 'react-bootstrap'
import MEModal from '../../components/MEModal'

export const AddPeopleModal = ({
  showAddPeopleModal,
  toggleAddPeopleModal,
  handlePeopleInfoChange,
  handleRoleSelectionChange,
  handleSectionSelection,
  handlePaymentRecordSelection,
  handleNotificationSelection,
  handleFormSubmit,
  sections,
  elevatedUser,
  daysOfAccess,
  handleEnforceAccessDays,
}) => {
  const [enforceAccessDefault, setEnforceAccess] = React.useState(true)
  const [requirePurchase, setRequirePurchase] = React.useState(true)

  const checkEnforceAccess = () => {
    handleEnforceAccessDays(!enforceAccessDefault)
    setEnforceAccess(!enforceAccessDefault)
  }

  const requirePurchaseSelection = e => {
    handlePaymentRecordSelection(e)
    setRequirePurchase(!requirePurchase)
  }

  const extraFormFields = (
    <Fragment>
      <Form.Group controlId="formControlsPaymentRecordSelect">
        <Form.Label>Create Payment Record</Form.Label>
        <Form.Control
          as="select"
          placeholder="select"
          onChange={e => requirePurchaseSelection(e)}
        >
          <option value="no">
            No. Require student(s) to purchase the book.
          </option>
          <option value="yes">
            Yes. Student(s) do not need to purchase the book.
          </option>
        </Form.Control>
      </Form.Group>
      {daysOfAccess > 0 && !requirePurchase && (
        <Form.Group controlId="formControlsEnforceDaysCheck">
          <Form.Check
            className="form-inline-b3"
            onChange={checkEnforceAccess}
            checked={enforceAccessDefault}
            label={`Enforce ${daysOfAccess} Days of Access`}
          />
        </Form.Group>
      )}
      <Form.Group controlId="formControlsNotifySelect">
        <Form.Label>Course Member Notification</Form.Label>
        <Form.Control
          as="select"
          placeholder="select"
          onChange={handleNotificationSelection}
        >
          <option value="no">No. Do not email anyone.</option>
          <option value="yes">Yes. Email the people who were added.</option>
        </Form.Control>
      </Form.Group>
    </Fragment>
  )
  return (
    <MEModal
      show={showAddPeopleModal}
      close={toggleAddPeopleModal}
      title="Add / Edit People"
    >
      <p>
        Enter/paste email address, first name, last name, student ID (optional)
        as shown in the box below, one person per line.
      </p>
      <p>
        If a given email address already exists in the system, the existing user
        will be added to the course. Otherwise, a new user account will be
        created with a temporary password and added to the course.
      </p>
      <p>
        Student IDs, if present, will always be updated.
      </p>
      <Form.Group controlId="formControlsTextArea">
        <Form.Label>
          Email Address, First Name, Last Name, Student ID (optional)
        </Form.Label>
        <Form.Control
          as="textarea"
          placeholder="john_doe@university.edu, John, Doe, 12345"
          onChange={handlePeopleInfoChange}
        />
      </Form.Group>
      <Form.Group controlId="formControlsRoleSelect">
        <Form.Label>Role</Form.Label>
        <Form.Control
          as="select"
          placeholder="select"
          onChange={handleRoleSelectionChange}
        >
          <option value="student">Student</option>
          <option value="mentor">Mentor</option>
          <option value="assistant">Teaching Assistant</option>
          <option value="instructor">Instructor</option>
          {elevatedUser ? <option value="manager">Manager</option> : null}
        </Form.Control>
      </Form.Group>
      <Form.Group controlId="formControlsSectionSelect">
        <Form.Label>Section</Form.Label>
        <Form.Control
          as="select"
          placeholder="select"
          onChange={handleSectionSelection}
        >
          {sections.map((x, key) => {
            return (
              <option key={key} value={x.secName}>
                {x.secName}
              </option>
            )
          })}
        </Form.Control>
      </Form.Group>
      {elevatedUser ? extraFormFields : null}
      <Button
        type="submit"
        variant="primary"
        className="btn-myed btn-primary-myed"
        onClick={handleFormSubmit}
      >
        Submit
      </Button>
      <Button
        type="button"
        variant="secondary"
        className="btn-myed btn-default-myed"
        onClick={toggleAddPeopleModal}
      >
        Cancel
      </Button>
    </MEModal>
  )
}

AddPeopleModal.propTypes = {
  showAddPeopleModal: PropTypes.bool,
  toggleAddPeopleModal: PropTypes.func,
  handlePeopleInfoChange: PropTypes.func,
  handleRoleSelectionChange: PropTypes.func,
  handleSectionSelection: PropTypes.func,
  handlePaymentRecordSelection: PropTypes.func,
  handleNotificationSelection: PropTypes.func,
  handleFormSubmit: PropTypes.func,
  sections: PropTypes.array,
  elevatedUser: PropTypes.bool,
  daysOfAccess: PropTypes.number,
  handleEnforceAccessDays: PropTypes.func,
}
